import { IRouteBuilderContext } from 'types';
import { Route } from 'react-router-dom';
import { asLazyLoadable } from 'lib/module';

const DefaultAppSettings = asLazyLoadable(() => import('./pages/default-app-settings-page'));

export default (context: IRouteBuilderContext) => (
    <>
        <Route key="default-app-settings-routes" path="/default-app-settings" element={<DefaultAppSettings />} />
    </>
);
